import HomeFooterNavigationListTitleText from "../../texts/homeScreen/HomeFooterNavigationListTitleText";
import HomeFooterNavigationItem from "../../items/homeScreen/HomeFooterNavigationItem";

export default function HomeFooterMainNavigationList({title, navItems}) {
    // Used to display footer list of main navigations links in the application

    // BUILD
    return (
        <div className={"flex flex-col space-y-[12px] justify-start items-start"}>
            <HomeFooterNavigationListTitleText title={title} />
            <div className={"flex flex-col space-y-[8px] justify-start items-start"}>
                {navItems.map((item, index) => (
                    <HomeFooterNavigationItem item={item} key={index} />
                ))}
            </div>
        </div>
    )
}